import React from 'react';
import styles from './DENTToothQuickSelected.module.scss';
import { joinClasses } from '../../../../Utils/className.util';
import { Tooth, ToothJaw } from '../../../../graphql/graphql';

interface Props {
	tooth: Tooth;
}

const DENTToothQuickSelected = ({ tooth }: Props) => {
	return (
		<div
			className={joinClasses([
				styles.wrapper,
				tooth.jaw === ToothJaw.Upper ? styles.upper : styles.lower,
			])}>
			<svg
				width='25'
				height='25'
				viewBox='0 0 40 40'
				xmlns='http://www.w3.org/2000/svg'>
				<circle cx='20' cy='20' r='19' fill='#fff' />
				<circle cx='20' cy='20' r='16' fill='#2196f3' />
				<path
					d='M14 20.5l4 4 8-8'
					fill='none'
					stroke='#fff'
					stroke-width='2.5'
					stroke-linecap='round'
					stroke-linejoin='round'
				/>
			</svg>
		</div>
	);
};

export default DENTToothQuickSelected;
